module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Haute-Sorne_COA-10dfcc034da85ebd951284f04cce3ff9.svg";